import React, { Component , useState} from 'react';
import Copyright from '../componentes/copyright';
import Principal from '../componentes/principal';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import {withRouter} from 'react-router-dom';
import { Container } from '@material-ui/core';
import firebase from "firebase/app";
import 'firebase/firestore';
import {authConfig} from '../auth/config';
import CardAprova from './cadAprova';
import {Link} from 'react-router-dom';

const classes = makeStyles((theme) => ({
   paper: {
     marginTop: theme.spacing(8),
     display: 'flex',
     flexGrow: 1,
     flexDirection: 'column',
     alignItems: 'center',
   },
   title: {
      display: 'none',
      [theme.breakpoints.up('sm')]: {
        display: 'block',
      },
    },
    menuButton: {
      marginRight: theme.spacing(2),
      marginTop: theme.spacing(20),
    },
    submit: {
      margin: theme.spacing(2, 2, 2),
  
     
  
    },
}));

document.title = 'Frota UFSM'
document.logo=''


var lotacao='';
var utipo='';
var depnome='';
var iduser= '';
export const  Consultas = withRouter(({history}) => {
   
  const [state, setState] = useState([]);

   React.useEffect(() => {
    
    

    async function pegauser() {
      const user = authConfig.auth().currentUser;
       var db = firebase.firestore();
       iduser=user.uid;
       var userref =  db.collection("usuarios").doc(user.uid);         
       console.log("esta aqui 001");
      await userref.get().then((doc) => {       
         if (doc.exists) {
           console.log("Document data pegouppqpq:", doc.data());
           utipo = doc.data().usertipo;
           lotacao = doc.data().lotacao;
           depnome=doc.data().depnome;
            console.log('porraaaaa' , doc.data().lotacao);
            pegalista();
         }else{
           alert('Não encontramos o seu cadastro')
         }
        
        }).catch(function(error) {
          alert("Erro ao localizar o seu cadastro ", error.message);
          })
    };

    async function pegalista() {          
      if(utipo==1) {
        console.log("user tipo poxa"+ lotacao + "puta merda");
        var db = firebase.firestore();
        var query = await db.collection("agenda").where("idsolicitante", "==", iduser,).where("status","==", "solicitado").get()
        .then(function(querySnapshot) {
        
         querySnapshot.forEach(function(doc) {
           var listausers=[];
             listausers.push({id: doc.id, datahoraretorno: doc.data().datahoraretorno,
              datahorasaida:doc.data().datahorasaida, depsolicitente: doc.data().depsolicitente, dsolicitacao: doc.data().dsolicitacao,
              listapassageiros: doc.data().listapassageiros, lotacaosolicitante: doc.data().lotacaosolicitante, nomesolicitante: doc.data().nomesolicitante,
              npassageiro: doc.data().npassageiro,nsolicitacao: doc.data().nsolicitacao,objetivo: doc.data().objetivo,
              siapesolicitente: doc.data().siapesolicitente,telefonesolicitante: doc.data().telefonesolicitante,listaparadas: doc.data().listaparadas,
              localdestino: doc.data().localdestino,localsaida: doc.data().localsaida, tipotransporte:doc.data().tipotransporte
            });
           console.log("agenda ", state );
          setState (currentArray => [...currentArray, listausers]);
          

          /////////////////////*
          
         
          
          /////////////////////////////////

         });
        
       })
      .catch(error => {
          console.log('Não encontramos veículos cadastrados', error);
      });
      
      }else {
        if(utipo==2) {
        console.log("user tipo poxa"+ lotacao + "puta merda");
        var db = firebase.firestore();
        var query = await db.collection("agenda").where("lotacaosolicitante", "==", lotacao,).where("depsolicitante","==", depnome).where("status","==", "solicitado").get()
        .then(function(querySnapshot) {
        
         querySnapshot.forEach(function(doc) {
           var listausers=[];
             listausers.push({id: doc.id, datahoraretorno: doc.data().datahoraretorno,
              datahorasaida:doc.data().datahorasaida, depsolicitente: doc.data().depsolicitente, dsolicitacao: doc.data().dsolicitacao,
              listapassageiros: doc.data().listapassageiros, lotacaosolicitante: doc.data().lotacaosolicitante, nomesolicitante: doc.data().nomesolicitante,
              npassageiro: doc.data().npassageiro,nsolicitacao: doc.data().nsolicitacao,objetivo: doc.data().objetivo,
              siapesolicitente: doc.data().siapesolicitente,telefonesolicitante: doc.data().telefonesolicitante,listaparadas: doc.data().listaparadas,
              localdestino: doc.data().localdestino,localsaida: doc.data().localsaida, tipotransporte:doc.data().tipotransporte
            });
           console.log("agenda ", state );
          setState (currentArray => [...currentArray, listausers]);
          
     });
        
       })
     .catch(error => {
         console.log('Não encontramos veículos cadastrados', error);
     });
     
     }else {
            if(utipo==3) {
              console.log("user tipo poxa"+ lotacao + "puta merda");
              var db = firebase.firestore();
              var query = await db.collection("agenda").where("lotacaosolicitante", "==", lotacao,).where("status","==", "solicitado").get()
              .then(function(querySnapshot) {
              
               querySnapshot.forEach(function(doc) {
                 var listausers=[];
                   listausers.push({id: doc.id, datahoraretorno: doc.data().datahoraretorno,
                    datahorasaida:doc.data().datahorasaida, depsolicitente: doc.data().depsolicitente, dsolicitacao: doc.data().dsolicitacao,
                    listapassageiros: doc.data().listapassageiros, lotacaosolicitante: doc.data().lotacaosolicitante, nomesolicitante: doc.data().nomesolicitante,
                    npassageiro: doc.data().npassageiro,nsolicitacao: doc.data().nsolicitacao,objetivo: doc.data().objetivo,
                    siapesolicitente: doc.data().siapesolicitente,telefonesolicitante: doc.data().telefonesolicitante,listaparadas: doc.data().listaparadas,
                    localdestino: doc.data().localdestino,localsaida: doc.data().localsaida, tipotransporte:doc.data().tipotransporte
                  });
                 console.log("agenda ", state );
                setState (currentArray => [...currentArray, listausers]);
                
      
                /////////////////////*
                
               
                
                /////////////////////////////////
      
               });
              
             })
           .catch(error => {
               console.log('Não encontramos veículos cadastrados', error);
           });
           
           }else {
           
            console.log("user tipo poxa"+ lotacao + "puta merda q eu sei");
              var db = firebase.firestore();
              console.log("user tipo poxa"+ lotacao + "puta merda q eu sei2");
              var query = await db.collection("agenda").where("status","==", 'solicitado').get()
              .then(function(querySnapshot) {
              
               querySnapshot.forEach(function(doc) {
                console.log("user tipo poxa"+ lotacao + "puta merda q eu sei3");
                 var listausers=[];
                   listausers.push({id: doc.id, datahoraretorno: doc.data().datahoraretorno,
                    datahorasaida:doc.data().datahorasaida, depsolicitente: doc.data().depsolicitente, dsolicitacao: doc.data().dsolicitacao,
                    listapassageiros: doc.data().listapassageiros, lotacaosolicitante: doc.data().lotacaosolicitante, nomesolicitante: doc.data().nomesolicitante,
                    npassageiro: doc.data().npassageiro,nsolicitacao: doc.data().nsolicitacao,objetivo: doc.data().objetivo,
                    siapesolicitente: doc.data().siapesolicitente,telefonesolicitante: doc.data().telefonesolicitante,listaparadas: doc.data().listaparadas,
                    localdestino: doc.data().localdestino,localsaida: doc.data().localsaida, tipotransporte:doc.data().tipotransporte
                  });
                 
                setState (currentArray => [...currentArray, listausers]);
                console.log("agenda ", state );
      
                /////////////////////*
                
               
                
                /////////////////////////////////
      
               });
              
             })
           .catch(error => {
               console.log('Não encontramos solicitações cadastrados', error);
           });
           
            
           }}
     
           
         
          }
      
    }
 
    pegauser()
    
  
  
  console.log('agora sim é o tamanho ', state.length);
  }, []); 

  //*****************************************************controle botões solicitações */
  function handlerandamento(){
    history.push('/Consultarandamento');  

}
 

function handleraprovada(){
  history.push('/Consultaraprovada');  
}

function handleraberto(){
  history.push('/Consultar');  
}

function handlerrealizadas(){
  history.push('/ConsultarRealizadas');  
}
return(
 
<Container >
<CssBaseline />
      
      <div id="cabeça" >
      <Principal/>
      
      
      </div>
      
      <Typography className={classes.title} variant="h5" noWrap align="center">
            Aprovar Solicitações
          </Typography>
          
      <div id="corpo"   align="center" className={classes.paper} >

         <div id="corpoveiculo">
           <Container maxWidth="xs">
            
              {console.log('tamanho da lista=> ', state)}
              {state.map(item=>(
              
              //console.log("oi" , item.id)
              <CardAprova props={item} key={item.id} />
                
              ))}

             </Container>
           </div>
          
          
      </div>
       
  
       <Box mt={3}>
          <Copyright/>
       </Box>
   
   
   </Container>
)

}

)
 
export default Consultas;
